"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectRange = void 0;
const uuid_1 = require("@lukeed/uuid");
const ml_spectra_processing_1 = require("ml-spectra-processing");
const nmr_processing_1 = require("nmr-processing");
function detectRange(spectrum, options) {
    const { from, to } = options;
    const { x, re: y } = spectrum.data;
    const absolute = (0, ml_spectra_processing_1.xyIntegration)({ x, y }, { from, to, reverse: true });
    const min = (0, ml_spectra_processing_1.xyMinYPoint)({ x, y }, { from, to }).y;
    const max = (0, ml_spectra_processing_1.xyMaxYPoint)({ x, y }, { from, to }).y;
    const shiftX = (0, nmr_processing_1.getShiftX)(spectrum);
    return {
        id: (0, uuid_1.v4)(),
        originalFrom: from - shiftX,
        originalTo: to - shiftX,
        from,
        to,
        absolute,
        min,
        max,
    };
}
exports.detectRange = detectRange;
